/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Pattern_Deleted_SuccessInputs */



/**
* | output |
* | --- |
* | "Pattern deleted successfully!" |
*
* @param {Compliance_Pattern_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_pattern_deleted_success = /** @type {((inputs?: Compliance_Pattern_Deleted_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Pattern_Deleted_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Muster erfolgreich gelöscht!")
	return /** @type {LocalizedString} */ ("Pattern deleted successfully!")
});